export default name => {
  const pattern = RegExp(`(^| |;)${name}=([^;]+)`);
  const matched = document.cookie.match(pattern);
  if (matched) {
    return matched[2];
  }
  return undefined;
};
